module.exports = __webpack_public_path__ + "static/media/StepFailed.d8072971.svg";